<template>
  <div class="lotus_content">
    <section class="box_page_content_2">
      <h3>{{ $t("rule.title") }}</h3>
      <div class="_thumb">
        <img src="@/assets/images/banner_rules.png" alt="" />
      </div>
      <div class="_des">
        <div align="left">
          <p style="margin: 0cm 0cm 8pt; line-height: 107%">
            <span
              style="
                font-size: 20px;
                line-height: 107%;
                font-family: Roboto, serif;
                font-weight: bold;
                color: #1f36c7;
              "
              >Cách thức rinh lộc:
            </span>
            <span style="
                font-size: 16px;
                line-height: 107%;
                font-family: Roboto, serif;
              ">
              Bấm vào nút “Quay ngay” để có cơ hội nhận được các phần quà hấp dẫn từ chương trình.
            </span>
          </p>
          <p style="margin: 0cm 0cm 8pt; line-height: 107%">
            <span
              style="
                font-size: 20px;
                line-height: 107%;
                font-family: Roboto, serif;
                font-weight: bold;
                color: #1f36c7;
              "
              >Thời gian chương trình:
            </span>
            <span
              style="
                font-size: 16px;
                line-height: 107%;
                font-family: Roboto, serif;
              "
            >
              22/02/2023 - 08/03/2023</span
            >
          </p>

          <p style="margin: 0cm 0cm 8pt; line-height: 107%">
            <span
              style="
                font-size: 16px;
                line-height: 107%;
                font-family: Roboto, serif;
              "
              >
              +Qúy khách hàng khi mua 1 triệu đồng sản phẩm chăm sóc da Unilever (Ponds, Hazeline, Vaseline) (giá bán không bao gồm thuế), quý khách hàng sẽ được 1 lượt quay

              <br>
                +Tối đa 10 lượt quay/1 khách hàng.
            </span>
          </p>
        </div>
      </div>
      <div class="_foot text-center">
        <router-link :to="{ name: 'luckyDraw' }" tag="a" class="btn btn-x2">
          <span>{{ $t("rule.button") }}</span>
        </router-link>
      </div>
      <footer class="d-flex flex-wrap px-content-1">
        <p class="flex-grow-1">
          Hotline: <a href="tel:1900299232">1900 299 232</a>
        </p>
        <p>
          <a href="javascript:;" class="d-flex align-items-center">
            <img src="@/assets/images/ub_logo.svg" />
            <span>Powered by UrBox</span>
          </a>
        </p>
      </footer>
    </section>
    <!--FOOTER-->
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Rules",
  data() {
    return {};
  },

  computed: {
    lang() {
      return this.$i18n.locale || "vi";
    },
  },
};
</script>

<style scoped lang="scss">
table,
td,
th {
  border: 1px solid;
}

table p {
  margin-bottom: 0;
}

ul p {
  margin-bottom: 0;
  line-height: 1.8;
}

table td {
  padding: 15px 10px;
}

table tr td:nth-child(2) {
  word-break: break-all;
}

table {
  width: 100%;
  border-collapse: collapse;
}
</style>
